import type { BaseObject, CubeLineId, CubeLinesType } from 'common/types'

import type { ActiveEntity, CubeId, CubeLines, CubeLineType } from '../types'

export const getLine = (cubeLinesList: CubeLines[], cubeLineId: CubeLineId) => {
  for (const cubeLines of cubeLinesList) {
    switch (cubeLineId) {
      case cubeLines.iLine.cubeLineId:
        return cubeLines.iLine
      case cubeLines.xLine.cubeLineId:
        return cubeLines.xLine
      case cubeLines.Hline.cubeLineId:
        return cubeLines.Hline
      default:
        break
    }
  }
}

export const getLineContext = (cubeLine: CubeLineType, lineType: CubeLinesType): ActiveEntity => {
  const entityType = getContextCubeLineType(lineType)

  return {
    entityType,
    entityId: cubeLine.cubeLineId,
    entityName: String(cubeLine.value),
  }
}

const isCubeId = (
  entityId: ActiveEntity['entityId'],
  entityType: ActiveEntity['entityType'],
): entityId is CubeId => {
  return entityType === 'cube'
}

export const getCubeId = (entity: ActiveEntity): CubeId | undefined => {
  const entityId = entity.entityId
  if (!entityId) return

  return isCubeId(entityId, entity.entityType) ? entityId : undefined
}

const getContextCubeLineType = (lineType: CubeLinesType): BaseObject => {
  switch (lineType) {
    case 'iLine':
      return 'iLineCut'
    case 'xLine':
      return 'xLineCut'
    case 'Hline':
      return 'hLineCut'
  }
}
